import { useAuthentication } from './useAuthentication';
import { AnonymousIdentity } from '../auth/Identity';
import { useCallback, useEffect, useState } from 'react';
function mapUser(user) {
    return user instanceof AnonymousIdentity ? undefined : user;
}
export const useIdentity = () => {
    const authentication = useAuthentication();
    const [currentUser, setUser] = useState(() => mapUser(authentication.currentUser));
    const refresh = useCallback(() => {
        setUser(mapUser(authentication.currentUser));
    }, [authentication]);
    useEffect(() => authentication.on('login', refresh), [authentication]);
    useEffect(() => authentication.on('logout', refresh), [authentication]);
    useEffect(() => authentication.on('expired', refresh), [authentication]);
    return currentUser;
};
//# sourceMappingURL=useIdentity.js.map